<!-- 返校优惠 -->
<template>
<div class="back-school-sale">
    <template v-for="(item,index) in list">
        <div class="sale-item vertical" v-if="item.type == 1" :key="index">
            <div class="ig"><a :href="item.url" target="_blank"><YorkbbsImage :src="item.images[0]" :aspect="true" borderRadius="4px" animation /></a></div>
            <div class="flex-cont colum-cont">
                <div class="title"><a :href="item.url" target="_blank">{{item.title}}</a></div>
                <div class="desc" v-if="item.desc">{{item.desc}}</div>
                <!-- <div class="tag-phone">
                    <div class="phone">{{item.phone}}</div>
                    <div class="tags">
                        <template v-for="(tag,index) in item.tags"><span :key="index">{{tag}}</span></template>
                    </div>
                     
                </div> -->
            </div>
        </div>
        <div class="sale-item " v-if="item.type == 2" :key="index">
            <div class="title"><a :href="item.url" target="_blank">{{item.title}}</a></div>
            <div class="img-cont">
                <template v-for="img in item.images">
                    <div class="img-item" :key="img">
                        <a :href="item.url" target="_blank"><YorkbbsImage :src="img"  :aspect="true" borderRadius="4px" animation /></a>
                    </div>
                </template>
            </div>
            <div class="bottom-phone-tag">
                <div class="phone">{{item.phone}}</div>
                <div class="tags">
                    <template v-for="(tag,index) in item.tags"><span :key="index">{{tag}}</span></template>
                </div>
            </div>
        </div>
    </template>
</div>
</template>
<script>
export default {
    name:'BackSchoolSale',
    data(){
        return  {
            list:[
                {
                    type:2,//type:1 大图，
                    title:'返校季新装备！这些电子产品好价快收',
                    tags:[],
                    images:[
                        'https://media3.imgyb.xyz/media/v1/image/8c0c2e16eda1a59543de550ebeb30542.png/watermark',
                        'https://media5.imgyb.xyz/media/v1/image/e1e591b91a9813535cb3dfeb8c8c3ccb.png',
                        'https://media1.imgyb.xyz/media/v1/image/1d32be635216af0ff52e6cfc3cf57ac5.png'
                    ],
                    phone:'',
                    url:'https://news.yorkbbs.ca/detail/deals/c51b1872-b7cb-4238-93dc-d857251317f6'
                },
                {
                    type:1,//type:1 大图，
                    title:'返校换新装！多伦多服装鞋履大促',
                    tags:[],
                    images:[
                        'https://media5.imgyb.xyz/media/v1/image/b6cae22d9935c58ae07e7ce101c7b6a2.png/watermark',
                        
                    ],
                    phone:'',
                    desc:'要美要帅钱包不能扁！Champion爆款五折、Banana Republic低至1.9折......',
                    url:'https://news.yorkbbs.ca/detail/deals/1c78e6d4-34d4-479b-818a-3aa66b14ace5'
                },
                {
                    type:1,//type:1 大图，
                    title:'返校装新家！多伦多租房居家好物合集',
                    tags:[],
                    images:[
                        'https://media3.imgyb.xyz/media/v1/image/1dc583012e2d5996bb731ef6ef1b4f6b.png/watermark',
                        
                    ],
                    phone:'',
                    desc:'多伦多学生要薅羊毛！Wayfair宿舍平价好物合集、Bbluv可折叠凳子、免费Pizza',
                    url:'https://news.yorkbbs.ca/detail/deals/63ebf9c6-fd0a-4f32-b331-fd51b5e14b32'
                },
            ]

        }
    }
}
</script>
<style lang="less" scoped>
.back-school-sale{
    .sale-item{
        padding: 20px 0; border-bottom: 1px solid #eee;
        &:last-child{border: none;} 
        &:first-child{padding-top: 0;}
        .title{font-size: 16px; line-height: 24px;margin-bottom: 10px;
            a:hover{color: #e43a3a;}
        }
        .img-cont{
            display: flex; margin: 0 -10px 5px;
            .img-item{padding: 0 10px; flex: 1;
                a{border:1px solid #eee; border-radius: 4px; display: block;}
            }
        }
        .bottom-phone-tag{
            display: flex; 
            .phone{flex:1;}
            .tags{
                span{
                    &:last-child{margin-right: 0;}
                }
            }
        }
        .tags{
            span{font-size:14px; color: #999; margin: 0 10px;}
        }
        .phone{font-size:16px ; color: #e43a3a; font-weight: 600;}
        .ig{width: 140px; margin-right: 20px;}
        .desc{font-size: 14px; line-height: 20px; color: #999;}
        &.vertical{
            display: flex;
            .flex-cont{flex:1}
        }
        .colum-cont{
            display: flex; flex-direction: column;
            .tag-phone{
                flex:1; display: flex; flex-direction: column; justify-content: space-between;
                .tags{
                    span:first-child{margin-left: 0;}
                }
            }
        }
    }
}
@media screen and (max-width:768px){
    .back-school-sale .sale-item .ig{width:90px}
    .back-school-sale{
        .sale-item{
            .desc{display: none;}
        }
    }
}
</style>